import '../scss/style.scss';

window.$ = window.jQuery = require('jquery');
window.lightbox = require('./libs/lightbox');

require('./libs/slick');
require('./libs/css3-animate-it');
require('./libs/sticky-sidebar.js');
require('./scrollbar');
require('./scrollup');
require('./header-menu');
require('./menu-mobile');
require('./sticky-header');
require('./slider');
require('./logo-slider');
require('./certificates');
require('./product-gallery');
require('./search-form');
require('./realizations-gallery');
require('./animated.js');
require('./news-slider');
require('./sidebar');
// require('./wcag');